var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"box"},[_c('img',{staticClass:"fill",style:(`transform: scale(1.35,${_vm.value/100});`),attrs:{"src":"/img/bar.webp"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }